// = Libs =
import * as Yup from 'yup';

const FORM = {
	VALIDATION: {
		string: Yup.string(),
		required_string: (message?: string) => Yup.string().required(message),
		required_date: (message?: string) => Yup.string().nullable(true).required(message),
		required_catalog: (message?: string) => Yup.object().shape({
			value: Yup.string(),
			label: Yup.string(),
		}).required(message).nullable(true),
		required_catalog_array: (message?: string) => Yup.array().of(Yup.object().shape({
			value: Yup.string(),
			label: Yup.string(),
		})).min(1, message).nullable(true).required(message),
	},

	MESSAGES: {
		required: 'Данное поле обязательно',
		not_valid: 'Введите все данные в поле',
	}
};

const { VALIDATION, MESSAGES } = FORM;

export { VALIDATION, MESSAGES };
